import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { UniRequest } from '@uniframe/toolkit';
import { TIMEOUT } from './constants';

// 创建 UniRequest 实例
var http = new UniRequest({
  credentials: 'include',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    platform: 'pc'
  },
  timeout: TIMEOUT
});

// 设置缓存删除策略
http.freezeCacheDeletion({
  '/symbol_list_all': 'manual',
  '/symbol_list_v2': 'manual',
  '/symbol_list_v3': 'manual'
});

// 添加请求拦截器
http.addInstanceRequestInterceptors([function (url, options) {
  // 请求时间
  options.requestTime = Date.now();
  return {
    url: url,
    options: options
  };
}]);

// 添加响应拦截器
http.addInstanceResponseInterceptors([/*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(response, _, operations) {
    var clonedResponse, result;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          clonedResponse = response.clone();
          _context.next = 4;
          return clonedResponse.json();
        case 4:
          result = _context.sent;
          if (result) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return", Promise.reject(operations.createResponseError('Non Response!', undefined)));
        case 7:
          return _context.abrupt("return", response);
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", Promise.reject(_context.t0));
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 10]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}()]);
export default http;